// Expandable and collapsible, multiple times.

up.compiler('.js-toggle_with_content', el => {
  const toggle = el.querySelector('.js-toggle_with_content__toggle')
  const content = el.querySelector('.js-toggle_with_content__content')

  const expand = () => {
    toggle.setAttribute('aria-expanded', 'true')
    content.removeAttribute('hidden')
  }

  const collapse = () => {
    toggle.setAttribute('aria-expanded', 'false')
    content.setAttribute('hidden', 'true')
  }

  const onClick = () => {
    toggle.getAttribute('aria-expanded') === 'true' ? collapse() : expand()
  }

  const init = () => {
    toggle.addEventListener('change', onClick)

    return () => {
      toggle.removeEventListener('change', onClick)
    }
  }

  return init()
})
